export type NestedPartial<T> = {
  [P in keyof T]?: NestedPartial<T[P]>;
};

export function assertPresent<T>(value: T | undefined | null): asserts value is T {
  if (!value) {
    throw new Error("Expected user to be present, but found " + String(value));
  }
}
